import { render, staticRenderFns } from "./BidderRegistration.vue?vue&type=template&id=acb51376&"
import script from "./BidderRegistration.vue?vue&type=script&lang=js&"
export * from "./BidderRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BidderRegistration.vue?vue&type=style&index=0&id=acb51376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports